/** Lightweight Dialog wrapper — no shadcn dependency, full control */
import { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, size = "lg" }) {
    useEffect(() => {
        function onKey(e) { if (e.key === "Escape") onClose?.(); }
        if (open) document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;
    const maxW = { sm: "max-w-md", md: "max-w-xl", lg: "max-w-3xl", xl: "max-w-5xl" }[size];

    return (
        <div
            data-testid="modal-backdrop"
            className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-start md:items-center justify-center p-4 md:p-10 overflow-y-auto"
            onClick={onClose}
        >
            <div
                className={`relative bg-white rounded-3xl shadow-2xl border border-black/5 w-full ${maxW} my-auto`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between p-6 border-b border-black/5">
                    <h2 className="font-display text-2xl tracking-tight">{title}</h2>
                    <button data-testid="modal-close" onClick={onClose} className="w-10 h-10 rounded-full hover:bg-black/5 flex items-center justify-center text-[#5C5C5C]">
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="p-6 md:p-8">
                    {children}
                </div>
            </div>
        </div>
    );
}
